/**
 * Slip check of a customer image (button under the image · api/app/slips.py). The result lands on the message
 * (`slip`) and reaches every screen as `message.updated`; this store only runs the request and remembers which
 * images are being checked on this screen.
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getApi } from '../api'
import { useInbox } from './inbox'

export const useSlips = defineStore('slips', () => {
  /** message id → a check started from this screen is running */
  const busy = ref<Record<string, boolean>>({})

  async function check(conversationId: string, messageId: string): Promise<void> {
    if (busy.value[messageId]) return
    busy.value = { ...busy.value, [messageId]: true }
    const inbox = useInbox()
    try {
      const res = await getApi().checkSlip(messageId)
      inbox.applyEvent({ type: 'message.updated', conversation_id: conversationId, item: res.message, conversation: res.conversation })
    } catch (e) {
      inbox.flash(`ตรวจสลิปไม่สำเร็จ: ${e instanceof Error ? e.message : String(e)}`)
    } finally {
      const next = { ...busy.value }
      delete next[messageId]
      busy.value = next
    }
  }

  return { busy, check }
})
